var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LvProgressBar',{staticStyle:{"height":"4px","border-radius":"0px"},attrs:{"value":_vm.increment,"showValue":false,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }